/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Bodyfat_EmptyInputs */

const en_us2_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No measurement yet. Without one, the app estimates from your weight.`)
};

const pt_br2_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma medida ainda. Sem ela, o app estima pelo peso.`)
};

const es_419_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay mediciones. Sin ellas, la app estima a partir de tu peso.`)
};

const pt_pt2_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda nenhuma medição. Sem ela, a app estima a partir do peso.`)
};

const fr_fr2_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore de mesure. Sans elle, l'app l'estime à partir de ton poids.`)
};

const de_de2_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Messung. Ohne sie schätzt die App anhand deines Gewichts.`)
};

const it_it2_profile_bodyfat_empty = /** @type {(inputs: Profile_Bodyfat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna misurazione. Senza, l'app stima dal peso.`)
};

/**
* | output |
* | --- |
* | "No measurement yet. Without one, the app estimates from your weight." |
*
* @param {Profile_Bodyfat_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_empty = /** @type {((inputs?: Profile_Bodyfat_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_empty(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_empty(inputs)
	return en_us2_profile_bodyfat_empty(inputs)
});
export { profile_bodyfat_empty as "profile.bodyfat_empty" }